let env = {};

// env.baseURL = 'http://localhost:8000/api/v1/';
// env.normalURL = 'http://localhost:8000/';
// env.mode = 'homolog';

env.baseURL = 'https://api.intranet-hml.it4d.com.br/api/v1/';
env.normalURL = 'https://api.intranet-hml.it4d.com.br/';
env.mode = 'homolog';

// env.baseURL = 'https://api.intranet.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.intranet.it4d.com.br/';
// env.mode = 'production';

env.webserviceHost = 'websocket.intranet.it4d.com.br';
env.webservicePort = 6009;

//env.mode = 'development';
//env.mode = 'contingencia';

export default env
